// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"64910560","81":"ad703ef4","129":"4156dfa1","304":"467ff915","894":"f1d8415e"}[chunkId] + ".chunk.js";
};